import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Cookies from 'js-cookie'
import axios from 'axios'
import { REGEX_EMAIL } from '../constants'
import Spinner from 'react-bootstrap/Spinner'
import Google from '../components/Blocks/Google'
import { addSlashButtonLink } from '../helper'
import { useScript } from '../hooks/useScript'
import { setOpenPopupSignUp, setPackageId, setIsLogin } from '../actions/common'
import { navigate } from '@reach/router'

const Header = () => {
     const mainMenu = useStaticQuery(graphql`
          query MainMenu {
               allWpMenu {
                    nodes {
                         menuItems {
                              nodes {
                                   url
                                   label
                              }
                         }
                         name
                    }
               }

               wp {
                    acfOptionsGeneralSiteSettings {
                         cfGeneralSiteSettings {
                              headerLogoSvg
                              masterClassLink {
                                   bottomTextMasterclass
                                   urlMasterclass
                                   turnOffMasterclass
                                   topTextMasterclass
                                   masterclassLogo
                              }
                              podcastLink {
                                   bottomTextPodcast
                                   urlPodcast
                                   turnOffPodcast
                                   topTextPodcast
                                   podcastLogo
                              }
                         }
                    }
               }
          }
     `)

     const menuItems = mainMenu.allWpMenu.nodes

     const headerLogo = mainMenu.wp.acfOptionsGeneralSiteSettings.cfGeneralSiteSettings.headerLogoSvg

     const {
          bottomTextMasterclass,
          urlMasterclass,
          turnOffMasterclass,
          topTextMasterclass,
          masterclassLogo,
     } = mainMenu.wp.acfOptionsGeneralSiteSettings.cfGeneralSiteSettings.masterClassLink

     const {
          bottomTextPodcast,
          urlPodcast,
          turnOffPodcast,
          topTextPodcast,
          podcastLogo,
     } = mainMenu.wp.acfOptionsGeneralSiteSettings.cfGeneralSiteSettings.podcastLink

     let headerMenu = null

     const [menuData] = useState([
          {
               label: 'Platform',
               link: '#',
               submenu: [
                    {
                         label: 'Define & Automate',
                         link: '#',
                         description: 'Centralize, automate, and distribute your marketing data.',
                         icon: 'icon-define',
                         backgroundColor: '#D0ECF5',
                         colorText: '#3BB2D0',
                         submenu: [
                              {
                                   label: 'Centralize Your Strategy',
                                   link: '/platform/centralized-marketing-data/',
                                   description: 'Define your conversions & KPIs in one place',
                              },
                              {
                                   label: 'Automate Your Data',
                                   link: '/platform/automate-marketing-data/',
                                   description: 'Collect marketing & website data faster, more accurately, and with less effort.',
                              },
                              {
                                   label: 'Improve Website Speed',
                                   link: '/platform/server-side-tagging/',
                                   description: 'Implement Server-side tagging to improve website speed and data reliability.',
                              },
                              {
                                   label: 'Distribute Your Data',
                                   link: '/platform/automate-conversion-and-event/',
                                   description: 'Send data to analytics & advertising platforms from a central point of truth.',
                              },
                         ],
                    },
                    {
                         label: 'Enhanced & Monitor',
                         link: '#',
                         description: 'Enrich your marketing data in ways you never thought possible.',
                         icon: 'icon-enhance',
                         backgroundColor: '#FCD2D2',
                         colorText: '#F86C6B',
                         submenu: [
                              {
                                   label: 'Enhance Your Data',
                                   link: '/platform/enhance/',
                                   description: 'Enrich your data by revealing real people and companies in your analytics.',
                              },
                              {
                                   label: 'Competitor Monitoring',
                                   link: '/platform/competitors/',
                                   description: 'Identiify competitors on your website, received notifications, and analyze behavior.',
                              },
                              {
                                   label: 'B2B Target Accounts',
                                   link: '/platform/target-accounts/',
                                   description: 'Build lists of Target Accounts and learn about their behavior on your website.',
                              },
                              {
                                   label: 'Monitor For Anomalies',
                                   link: '/platform/monitoring/',
                                   description: 'Improve data quality by monitoring for anomolies automatically or with custom rules.',
                              },
                              {
                                   label: 'External Data',
                                   link: '/platform/external-data/',
                                   description: 'Connect external data to build a central, single source of truth.',
                              },
                         ],
                    },
                    {
                         label: 'Learn & Optimize',
                         link: '#',
                         description: 'Gain insights and optimize with marketing analytics and revenue attribution.',
                         icon: 'icon-learn',
                         backgroundColor: '#F3F3FA',
                         colorText: '#8A8ACB',
                         submenu: [
                              {
                                   label: 'Gain Insights',
                                   link: '/platform/google-analytics-alternative/',
                                   description: 'Replace or augment Google Analytics with a better alternative.',
                              },
                              {
                                   label: 'UX Insights',
                                   link: '#',
                                   description: 'Session recordings and heatmaps built into your analytics data automatically. ',
                                   comingSoon: true,
                              },
                              {
                                   label: 'Revenue Attribution',
                                   link: '/platform/attribution/',
                                   description: 'Connect external data sources to attribute pipeline and revenue to marketing activity.',
                              },
                              {
                                   label: 'AI Marketing Insights',
                                   link: '/platform/ai-insights/',
                                   description: 'Traing your own LLM to generate insights from your data and strategy',
                              },
                              // {
                              //      label: 'eCommerce Analytics',
                              //      // link: '/platform/learn-and-optimize/analytics/',
                              //      link: '#',
                              //      description: 'Measure eCommerce acitivity to understand ROI and LTV.',
                              //      comingSoon: true,
                              // },
                         ],
                    },
                    {
                         label: 'Achieve Compliance',
                         link: '#',
                         description: 'Centralize and validate compliance across GDPRA, CCPA, HIPAA and more.',
                         icon: 'icon-achieve',
                         backgroundColor: '#EBF3F8',
                         colorText: '#3887BE',
                         submenu: [
                              {
                                   label: 'Consent Management Platform',
                                   link: '/platform/consent/',
                                   description: 'Replace or augment your CMP tool for GDPR, CCPA, and more.',
                              },
                              {
                                   label: 'HIPAA Compliance',
                                   link: '/platform/hippa/',
                                   description: 'Marketing Analytics & tagging solution for healthcare organizations.',
                              },
                              {
                                   label: 'Cookieless Tracking',
                                   link: '/platform/cookieless/',
                                   description: 'Achieve cookieless, first-party tracking across your website.',
                              },
                         ],
                    },
               ],
          },
          {
               label: 'Outcomes',
               link: '#',
               submenu: [
                    {
                         label: 'Marketing Leaders',
                         link: '/outcomes/marketing-leaders/',
                         description: 'Revenue insights for success',
                    },
                    {
                         label: 'Marketing Specialists',
                         link: '/outcomes/marketing-specialists/',
                         description: 'Streamline reporting & insights',
                    },
                    {
                         label: 'Measurement Professionals',
                         link: '/outcomes/measurement-pros/',
                         description: "Superpowers you've always wanted",
                    },
                    {
                         label: 'Marketing & Sales Ops',
                         link: '/outcomes/marketing-sales-ops/',
                         description: 'Bridge marketing and sales data',
                         // comingSoon: true,
                    },
                    {
                         label: 'Engineers & IT',
                         link: '/outcomes/engineers-and-it/',
                         description: 'Security & technology from the future',
                    },
                    {
                         label: 'B2B Marketers',
                         link: '/outcomes/b2b-marketing-analytics/',
                         description: 'Campaign analytics, audience insights, & revenue attribution',
                    },
                    {
                         label: 'B2C Marketers',
                         // link: '/outcomes/b2c/',
                         link: '/outcomes/b2c-marketing-analytics/',
                         description: 'Advanced eCommerce, lead attribution, & behavioral insights',
                    },
                    {
                         label: 'Healthcare Organizations',
                         // link: '/outcomes/healthcare/',
                         link: '/outcomes/hipaa-marketing-data/',
                         description: 'Marketing analytics and conversion tracking that is HIPAA compliant',
                         comingSoon: true,
                    },
                    {
                         label: 'Agencies',
                         link: '/outcomes/agencies/',
                         description: 'Prove results, deliver insights',
                    },
               ],
          },
          {
               label: 'Use Cases',
               link: '#',
               submenu: [
                    {
                         label: 'Listeners',
                         link: '/listeners/',
                         description: 'ListenLayer automates data from tools you already use. Search the library to learn more.',
                    },
                    {
                         label: 'Destinations',
                         link: '/marketing-data-platforms/',
                         description: 'Distribute data & conversions to the marketing and analytics tools that you already use.',
                    },
                    {
                         label: 'Use Cases',
                         link: '/use-cases/',
                         description: 'Browse our library of specific use cases and scenarios.',
                    },
               ],
          },
          {
               label: 'Pricing',
               link: 'https://listenlayerdv.wpengine.com/pricing/',
               submenu: [],
          },
     ])

     menuItems.forEach(menuItem => {
          if (menuItem.name === 'Main Menu') {
               headerMenu = menuItem.menuItems.nodes
          }
     })

     const [isActiveMenu, setIsActiveMenu] = useState(false)
     const [openLoginPopup, setOpenLoginPopup] = useState(false)
     const [email, setEmail] = useState()
     const [errorEmail, setErrorEmail] = useState()
     const [password, setPassword] = useState()
     const [errorPassword, setErrorPassword] = useState()
     const [errorForm, setErrorForm] = useState()
     const [firstName, setFirstName] = useState()
     const [errorFirstName, setErrorFirstName] = useState()
     const [lastName, setLastName] = useState()
     const [errorLastName, setErrorLastName] = useState()
     const [loading, setLoading] = useState(false)
     const [successRegister, setSuccessRegister] = useState()
     const dispatch = useDispatch()
     const isOpenPopupSignUp = useSelector(state => state.theme.isOpenPopupSignUp)
     const packageId = useSelector(state => state.theme.packageId)
     const isLogin = useSelector(state => state.theme.isLogin)
     const [showLearnBox, setShowLearnBox] = useState(false)
     const darkMode = useSelector(state => state.theme.darkModeRedux)
     // Menu Dropdown ==========================================================================================
     function extractStructuredData(data) {
          const result = []

          function extractLinks(item) {
               const childrenLinks = []

               if (item.submenu && item.submenu.length > 0) {
                    for (const subItem of item.submenu) {
                         const subItemLinks = extractLinks(subItem)
                         childrenLinks.push(...subItemLinks)
                    }
               }

               if (item.link && item.link !== '#') {
                    childrenLinks.push(item.link)
               }

               return childrenLinks
          }

          for (const parentItem of data) {
               const parentName = parentItem.label
               const subMenu = parentItem.submenu

               const childrenLinks = []

               if (subMenu && subMenu.length > 0) {
                    for (const subItem of subMenu) {
                         const subItemLinks = extractLinks(subItem)
                         childrenLinks.push(...subItemLinks)
                    }
               }

               if (parentName === 'Platform') {
                    childrenLinks.push('/platform/')
               }

               result.push({ label: parentName, children: childrenLinks })
          }

          return result
     }
     const extractedDataURLMenu = extractStructuredData(menuData)

     const [activeLevel1Item, setActiveLevel1Item] = useState(null)
     const [activeLevel2Item, setActiveLevel2Item] = useState(null)
     const [stylesActive, setStylesActive] = useState({})
     const [ipAddress, setIpAddress] = useState(null);

     function isPathInLabelChildren(label, pathname) {
          const labelObject = extractedDataURLMenu.find(item => item.label === label)

          if (!labelObject || !Array.isArray(labelObject.children)) {
               return false
          }

          return labelObject.children.includes(pathname)
     }

     const handleLevel1ItemClick = index => {
          console.log(index)
          if (index === activeLevel1Item) {
               setActiveLevel1Item(null)
               setActiveLevel2Item(null)
          } else {
               setActiveLevel1Item(index)
               setActiveLevel2Item(null)
          }
     }

     const handleLevel2ItemClick = (e, index, itemSub) => {
          setStylesActive({ '--backgroundColor': itemSub.backgroundColor, '--colorText': itemSub.colorText })
          if (index === activeLevel2Item) {
               setActiveLevel2Item(null)
          } else {
               setActiveLevel2Item(index)
          }
     }

     const handleMenuLeave = event => {
          const trigger = document.querySelectorAll('.menu-item')
          const submenu = document.querySelector('.submenu.active')

          if (
               trigger &&
               !Array.from(trigger).some(item => item.contains(event.target)) &&
               submenu &&
               !submenu.contains(event.target) &&
               activeLevel1Item !== null
          ) {
               setActiveLevel1Item(null)
               setActiveLevel2Item(null)
          }
     }

     useEffect(() => {
          const getCloudflareJSON = async () => {
               try {
                    let data = await fetch('https://www.cloudflare.com/cdn-cgi/trace').then((res) => res.text());
                    let arr = data
                         .trim()
                         .split('\n')
                         .map((e) => e.split('='));
                    return Object.fromEntries(arr);
               } catch (error) {
                    console.error('Error fetching data:', error);
                    return null;
               }
          };
  
          const fetchData = async () => {
               const res = await getCloudflareJSON();
               setIpAddress(res?.ip);
          };
  
          fetchData();
     }, []);

     useEffect(() => {
          document.addEventListener('click', handleMenuLeave)
          return () => {
               document.removeEventListener('click', handleMenuLeave)
          }
     }, [activeLevel1Item])

     const badgeComingSoon = () => {
          return <span className="label-comingsoon"></span>
     }

     // const badgeComingSoon = () => {
     //      return <img src={`/images/coming-soon-badges.svg`} alt="Coming Soon Badges" />
     // }

     const renderSubmenuItems = (itemSub, index) => {
          const backgroundIcon = { background: itemSub.backgroundColor }
          return (
               <div
                    className={`submenu-item ${activeLevel2Item === index ? 'active' : ''}`}
                    key={index}
                    onClick={e => {
                         handleLevel2ItemClick(e, index, itemSub)
                    }}
               >
                    {itemSub.icon ? (
                         <img style={backgroundIcon} className={'icon-menu'} src={`/images/${itemSub.icon}-nb.svg`} alt="Arrow Right Icon" />
                    ) : (
                         ''
                    )}
                    <div className="submenu-item-content">
                         <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                              <span>{itemSub.label}</span>
                              {itemSub.comingSoon && badgeComingSoon()}
                         </div>
                         <span>{itemSub.description}</span>
                    </div>
                    <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
               </div>
          )
     }

     const renderSubmenuItemsMobile = (itemSub, index) => {
          return (
               <>
                    <div
                         className={`submenu-item ${activeLevel2Item === index ? 'active' : ''}`}
                         key={index}
                         onClick={e => {
                              handleLevel2ItemClick(e, index, itemSub)
                         }}
                    >
                         <div className="submenu-item-content">
                              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                   <span>{itemSub.label}</span>
                                   {itemSub.comingSoon && badgeComingSoon()}
                              </div>
                         </div>
                         <img
                              className={`icon ${activeLevel2Item === index ? 'active' : ''}`}
                              src={`/images/icon-chevron-right.svg`}
                              alt="Arrow Right Icon"
                         />
                    </div>
                    {activeLevel2Item !== null && activeLevel2Item === index && (
                         <div className="submenu-lv2-mobile">
                              {itemSub?.submenu.map(i => {
                                   return (
                                        <div className={'d-flex align-items-center'} style={{ gap: '10px' }}>
                                             {i.link !== '#' ? (
                                                  <>
                                                       <Link
                                                            // partiallyActive={true}
                                                            // activeClassName="active"
                                                            to={addSlashButtonLink(i.link)}
                                                            className="submenu-lv2-item-mobile"
                                                       >
                                                            {i.label}
                                                       </Link>
                                                       {i.comingSoon && badgeComingSoon()}
                                                  </>
                                             ) : (
                                                  <>
                                                       <div className="submenu-lv2-item-mobile">{i.label}</div>
                                                       {i.comingSoon && badgeComingSoon()}
                                                  </>
                                             )}
                                        </div>
                                   )
                              })}
                         </div>
                    )}
               </>
          )
     }

     const renderSubmenuItemsOther = (itemSub, index) => {
          return (
               index < 5 &&
               (itemSub.link !== '#' ? (
                    <Link
                         // partiallyActive={true}
                         // activeClassName="active"
                         to={addSlashButtonLink(itemSub.link)}
                         className={`submenu-item other`}
                         key={index}
                    >
                         <div className="submenu-item-content">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                   <span>{itemSub.label}</span>
                                   {itemSub.comingSoon && badgeComingSoon()}
                              </div>
                              <span>{itemSub.description}</span>
                         </div>
                         <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
                    </Link>
               ) : (
                    <div className={`submenu-item other`} key={index} style={{ cursor: 'default' }}>
                         <div className="submenu-item-content">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                   <span>{itemSub.label}</span>
                                   {itemSub.comingSoon && badgeComingSoon()}
                              </div>
                              <span>{itemSub.description}</span>
                         </div>
                         <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
                    </div>
               ))
          )
     }

     const renderSubmenuItemsDefault = (itemSub, index) => {
          return itemSub.link !== '#' ? (
               <Link
                    // partiallyActive={true}
                    // activeClassName="active"
                    to={addSlashButtonLink(itemSub.link)}
                    className={`submenu-item default`}
                    key={index}
               >
                    <div className="submenu-item-content">
                         <span>{itemSub.label}</span>
                         <span>{itemSub.description}</span>
                    </div>
                    <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
               </Link>
          ) : (
               <div className={`submenu-item default`} key={index}>
                    <div className="submenu-item-content">
                         <span>{itemSub.label}</span>
                         <span>{itemSub.description}</span>
                    </div>
                    <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
               </div>
          )
     }

     const renderSubmenuItemsOtherMobile = (itemSub, index) => {
          return (
               index < 5 &&
               (itemSub.link !== '#' ? (
                    <Link
                         // partiallyActive={true}
                         // activeClassName="active"
                         to={addSlashButtonLink(itemSub.link)}
                         className={`submenu-item other`}
                         key={index}
                    >
                         <div className="submenu-item-content">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                   <span>{itemSub.label}</span>
                                   {itemSub.comingSoon && badgeComingSoon()}
                              </div>
                         </div>
                         <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
                    </Link>
               ) : (
                    <div className={`submenu-item other`} key={index} onClick={e => e.stopPropagation()}>
                         <div className="submenu-item-content">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                   <span>{itemSub.label}</span>
                                   {itemSub.comingSoon && badgeComingSoon()}
                              </div>
                         </div>
                         <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
                    </div>
               ))
          )
     }

     const renderSubmenuItemsOther2 = (itemSub, index) => {
          return (
               index > 4 &&
               (itemSub.link !== '#' ? (
                    <Link
                         // partiallyActive={true}
                         // activeClassName="active"
                         to={addSlashButtonLink(itemSub.link)}
                         className={`submenu-item other`}
                         key={index}
                    >
                         <div className="submenu-item-content">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                   <span>{itemSub.label}</span>
                                   {itemSub.comingSoon && badgeComingSoon()}
                              </div>
                              <span>{itemSub.description}</span>
                         </div>
                         <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
                    </Link>
               ) : (
                    <div className={`submenu-item other`} key={index} style={{ cursor: 'default' }}>
                         <div className="submenu-item-content">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                   <span>{itemSub.label}</span>
                                   {itemSub.comingSoon && badgeComingSoon()}
                              </div>
                              <span>{itemSub.description}</span>
                         </div>
                         <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
                    </div>
               ))
          )
     }

     const renderSubmenuItemsOther2Mobile = (itemSub, index) => {
          return (
               index > 4 &&
               (itemSub.link !== '#' ? (
                    <Link
                         // partiallyActive={true}
                         // activeClassName="active"
                         to={addSlashButtonLink(itemSub.link)}
                         className={`submenu-item other`}
                         key={index}
                    >
                         <div className="submenu-item-content">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                   <span>{itemSub.label}</span>
                                   {itemSub.comingSoon && badgeComingSoon()}
                              </div>
                         </div>
                         <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
                    </Link>
               ) : (
                    <div className={`submenu-item other`} key={index} onClick={e => e.stopPropagation()}>
                         <div className="submenu-item-content">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                   <span>{itemSub.label}</span>
                                   {itemSub.comingSoon && badgeComingSoon()}
                              </div>
                         </div>
                         <img src={`/images/icon-chevron-right.svg`} alt="Arrow Right Icon" />
                    </div>
               ))
          )
     }

     const renderMenuItems = (items, level) => {
          return (
               <ul className={`menu-level-${level}`} style={stylesActive}>
                    {items.map((item, index) => (
                         <li key={index} className={`menu-item level-${level}-item ${activeLevel1Item === index ? 'active' : ''}`}>
                              <div className="indicator"></div>

                              {item.link !== '#' ? (
                                   <Link
                                        partiallyActive={true}
                                        activeClassName="active"
                                        to={addSlashButtonLink('/pricing/')}
                                        className={`menu-label ${
                                             activeLevel1Item === index ||
                                             isPathInLabelChildren(item.label, typeof window !== 'undefined' ? window.location.pathname : '')
                                                  ? 'active'
                                                  : ''
                                        } `}
                                   >
                                        {item.label}
                                   </Link>
                              ) : (
                                   <p
                                        onClick={() => handleLevel1ItemClick(index)}
                                        className={`menu-label ${
                                             activeLevel1Item === index ||
                                             isPathInLabelChildren(item.label, typeof window !== 'undefined' ? window.location.pathname : '')
                                                  ? 'active'
                                                  : ''
                                        }`}
                                   >
                                        {item.label}
                                   </p>
                              )}
                              {/* <Link partiallyActive={true} activeClassName="active" to={addSlashButtonLink(item.link)} onClick={() => handleLevel1ItemClick(index)} className={`menu-label ${activeLevel1Item === index ? 'active' : ''} ${typeof window !== 'undefined' ? window.location.pathname : ''.includes('pricing') && index === 3 ? 'active' : ''}`}>{item.label}</Link> */}
                              {item.submenu && item.submenu.length > 0 && activeLevel1Item === index && (
                                   <div
                                        className={`submenu ${activeLevel1Item === index ? 'active' : ''} ${
                                             activeLevel2Item !== null ? 'submenu-lv2' : ''
                                        } ${index === 1 ? 'other' : ''} ${index === 2 ? 'useCase' : ''}`}
                                        onClick={e => {
                                             e.stopPropagation()
                                        }}
                                   >
                                        {index === 0 ? (
                                             <>
                                                  <div className={'submenu-lv1'}>
                                                       <Link
                                                            partiallyActive={true}
                                                            activeClassName="active"
                                                            to={addSlashButtonLink('/platform/')}
                                                            className="submenu-header"
                                                       >
                                                            <span>How it Works</span>
                                                            <span>Discover how ListenLayer works</span>
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                                 <path d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" />
                                                            </svg>
                                                       </Link>
                                                       <div className={`submenu-content`}>
                                                            {item.submenu.map((itemSub, index) => {
                                                                 return renderSubmenuItems(itemSub, index)
                                                            })}
                                                       </div>
                                                  </div>
                                                  {activeLevel2Item !== null && (
                                                       <div className={'submenu-lv2'}>
                                                            {item?.submenu?.[activeLevel2Item]?.submenu?.map((item, index) => {
                                                                 return item.link !== '#' ? (
                                                                      <Link
                                                                           partiallyActive={true}
                                                                           activeClassName="active"
                                                                           to={addSlashButtonLink(item.link)}
                                                                           className="submenu-lv2-item"
                                                                           key={`${item - index}`}
                                                                      >
                                                                           <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                                <span>{item.label}</span>
                                                                                {item.comingSoon && badgeComingSoon()}
                                                                           </div>
                                                                           <span>{item.description}</span>
                                                                      </Link>
                                                                 ) : (
                                                                      <div className="submenu-lv2-item" key={`${item - index}`}>
                                                                           <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                                <span>{item.label}</span>
                                                                                {item.comingSoon && badgeComingSoon()}
                                                                           </div>
                                                                           <span>{item.description}</span>
                                                                      </div>
                                                                 )
                                                            })}
                                                       </div>
                                                  )}
                                             </>
                                        ) : index === 1 ? (
                                             <div className={'submenu-lv1'}>
                                                  <div
                                                       className="submenu-header"
                                                       style={{
                                                            width: '814px',
                                                            height: '72px',
                                                            background: '#F8F9FA',
                                                            padding: '14px 28px 14px 21px',
                                                            borderRadius: '9px',
                                                       }}
                                                  >
                                                       <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                            <span>Data to Boost Marketing ROI.</span>
                                                            <span>ListenLayer drives outcomes across businesses and agencies.</span>
                                                       </div>
                                                       <Link
                                                            partiallyActive={true}
                                                            activeClassName="active"
                                                            to={addSlashButtonLink('/outcomes/')}
                                                            style={{
                                                                 display: 'flex',
                                                                 gap: '11px',
                                                                 alignItems: 'center',
                                                                 color: '#20a8d8',
                                                                 textDecoration: 'underline',
                                                                 textDecorationColor: '#20a8d8',
                                                            }}
                                                       >
                                                            Overview
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                                 <path d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" />
                                                            </svg>
                                                       </Link>
                                                  </div>
                                                  <div style={{ display: 'flex', gap: '34px' }}>
                                                       <div
                                                            className={`submenu-content`}
                                                            style={{ padding: '20px 0px 0px 23px', width: '320px', gap: 0 }}
                                                       >
                                                            <div style={{ fontSize: '16px', fontWeight: 700, lineHeight: '25px', color: '#73818f' }}>
                                                                 Outcomes by Role
                                                            </div>
                                                            {item.submenu.map((itemSub, index) => {
                                                                 return renderSubmenuItemsOther(itemSub, index)
                                                            })}
                                                       </div>
                                                       <div
                                                            className={`submenu-content`}
                                                            style={{ padding: '20px 0px 0px 11px', width: '444px', gap: 0 }}
                                                       >
                                                            <div style={{ fontSize: '16px', fontWeight: 700, lineHeight: '25px', color: '#73818f' }}>
                                                                 Outcomes by Business Type
                                                            </div>
                                                            {item.submenu.map((itemSub, index) => {
                                                                 return renderSubmenuItemsOther2(itemSub, index)
                                                            })}
                                                       </div>
                                                  </div>
                                             </div>
                                        ) : (
                                             <div className={'submenu-lv1'}>
                                                  <div className={`submenu-content`} style={{ gap: '10px', padding: 0 }}>
                                                       {item.submenu.map((itemSub, index) => {
                                                            return renderSubmenuItemsDefault(itemSub, index)
                                                       })}
                                                  </div>
                                             </div>
                                        )}
                                   </div>
                              )}
                         </li>
                    ))}
               </ul>
          )
     }

     const renderMenuItemsMobile = (items, level) => {
          return (
               <ul className={`menu-level-${level}`} style={stylesActive}>
                    {items.map((item, index) => (
                         <li
                              key={index}
                              style={{ cursor: 'pointer' }}
                              className={`menu-item level-${level}-item ${activeLevel1Item === index ? 'active' : ''}`}
                              onClick={() => handleLevel1ItemClick(index)}
                         >
                              <div className="indicator"></div>
                              {item.link !== '#' ? (
                                   <Link
                                        partiallyActive={true}
                                        activeClassName="active"
                                        to={addSlashButtonLink('/pricing/')}
                                        className={`menu-label ${
                                             activeLevel1Item === index ||
                                             isPathInLabelChildren(item.label, typeof window !== 'undefined' ? window.location.pathname : '')
                                                  ? 'active'
                                                  : ''
                                        }`}
                                   >
                                        {item.label}
                                   </Link>
                              ) : (
                                   <p
                                        // onClick={() => handleLevel1ItemClick(index)}
                                        className={`menu-label ${
                                             activeLevel1Item === index ||
                                             isPathInLabelChildren(item.label, typeof window !== 'undefined' ? window.location.pathname : '')
                                                  ? 'active'
                                                  : ''
                                        }`}
                                   >
                                        {item.label}
                                   </p>
                              )}
                              {/* <Link partiallyActive={true} activeClassName="active" to={addSlashButtonLink(item.link)} onClick={() => handleLevel1ItemClick(index)} className={`menu-label ${activeLevel1Item === index ? 'active' : ''} ${window.location.pathname.includes('pricing') && index === 3 ? 'active' : ''}`}>{item.label}</Link> */}
                              {/* {item.submenu && item.submenu.length > 0 && activeLevel1Item === index && ( */}
                              <div
                                   className={`submenu ${activeLevel1Item === index && item.label !== 'Pricing' ? 'active' : ''} ${
                                        activeLevel2Item !== null ? 'submenu-lv2' : ''
                                   } ${index === 1 ? 'other' : ''} ${index === 2 ? 'useCase' : ''}`}
                                   onClick={e => {
                                        e.stopPropagation()
                                   }}
                              >
                                   {index === 0 ? (
                                        <>
                                             <div className={'submenu-lv1'}>
                                                  <Link
                                                       // partiallyActive={true}
                                                       // activeClassName="active"
                                                       to={addSlashButtonLink('/platform/')}
                                                       className="submenu-header"
                                                  >
                                                       <span>How it Works</span>
                                                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                            <path d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" />
                                                       </svg>
                                                  </Link>
                                                  <div className={`submenu-content`}>
                                                       {item.submenu.map((itemSub, index) => {
                                                            return renderSubmenuItemsMobile(itemSub, index)
                                                       })}
                                                  </div>
                                             </div>
                                        </>
                                   ) : index === 1 ? (
                                        <div className={'submenu-lv1'}>
                                             <div className="submenu-header">
                                                  <Link
                                                       style={{ minWidth: '300px' }}
                                                       partiallyActive={true}
                                                       activeClassName="active"
                                                       to={addSlashButtonLink('/outcomes/')}
                                                       className="d-flex align-items-center justify-content-between"
                                                  >
                                                       <span style={{ fontSize: '15px', fontWeight: 700, color: '#20A8D8' }}>
                                                            Data to Boost Marketing ROI.
                                                       </span>

                                                       <svg
                                                            style={{ textDecoration: 'underline', marginLeft: '15px', color: '#20A8D8' }}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                       >
                                                            <path d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" />
                                                       </svg>
                                                  </Link>
                                             </div>
                                             <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                  <div className={`submenu-content`} style={{ padding: '0', gap: '20px' }}>
                                                       <div style={{ fontSize: '16px', fontWeight: 700, lineHeight: '25px', color: '#73818f' }}>
                                                            Outcomes by Role
                                                       </div>
                                                       {item.submenu.map((itemSub, index) => {
                                                            return renderSubmenuItemsOtherMobile(itemSub, index)
                                                       })}
                                                  </div>
                                                  <div className={`submenu-content`} style={{ padding: '20px 0px 0px 0', gap: '20px' }}>
                                                       <div style={{ fontSize: '16px', fontWeight: 700, lineHeight: '25px', color: '#73818f' }}>
                                                            Outcomes by Business Type
                                                       </div>
                                                       {item.submenu.map((itemSub, index) => {
                                                            return renderSubmenuItemsOther2Mobile(itemSub, index)
                                                       })}
                                                  </div>
                                             </div>
                                        </div>
                                   ) : (
                                        <div className={'submenu-lv1'}>
                                             <div className={`submenu-content`} style={{ padding: '10px 0 0 0', gap: '20px' }}>
                                                  {item.submenu.map((itemSub, index) => {
                                                       return renderSubmenuItemsOtherMobile(itemSub, index)
                                                  })}
                                             </div>
                                        </div>
                                   )}
                              </div>
                              {/* )} */}
                         </li>
                    ))}
               </ul>
          )
     }

     //======================================================================================

     const clickHamburger = () => {
          setIsActiveMenu(!isActiveMenu)
     }

     const closePopup = () => {
          setFirstName()
          setLastName()
          setEmail()
          setPassword()
          setSuccessRegister()
          setErrorForm()
          setOpenLoginPopup(false)
          setErrorEmail()
          setErrorPassword()
          setErrorFirstName()
          setErrorLastName()
          dispatch(setOpenPopupSignUp(false))
          dispatch(setPackageId(''))
     }

     const handleSubmitForm = event => {
          event.preventDefault()
          let emailMess = ''
          let passwordMess = ''

          if (!email) {
               emailMess = 'Email is required'
          } else if (!REGEX_EMAIL.test(email)) {
               emailMess = 'Not a valid email'
          }

          if (!password) {
               passwordMess = 'Password is required'
          } else if (password.length < 8) {
               passwordMess = 'Password must be at least  8 characters'
          }

          setErrorEmail(emailMess)
          setErrorPassword(passwordMess)

          if (!emailMess && !passwordMess) {
               setLoading(true)
               axios.post(`${process.env.GATSBY_CALL_API}/signin/`, {
                    email: email,
                    password: password,
                    ipAddress: ipAddress
               })
                    .then(response => {
                         dispatch(setIsLogin(true))
                         setLoading(false)
                         setErrorForm()
                         Cookies.set('token', response.data.token, {
                              expires: 1,
                              domain: '.listenlayer.com',
                         })
                         window.open(process.env.GATSBY_APP_PATH)
                         window.location.reload()
                    })
                    .catch(error => {
                         setLoading(false)
                         const message = error.response.data.message || error.response.data.error
                         setErrorForm(message || error.response.statusText)
                    })
          }
     }

     const handleSubmitFormRegister = event => {
          event.preventDefault()
          let firstNameMess = ''
          let lastNameMess = ''
          let emailMess = ''
          let passwordMess = ''

          if (!email) {
               emailMess = 'Email is required'
          } else if (!REGEX_EMAIL.test(email)) {
               emailMess = 'Not a valid email'
          }

          if (!password) {
               passwordMess = 'Password is required'
          } else if (password.length < 8) {
               passwordMess = 'Password must be at least  8 characters'
          }

          if (!firstName) {
               firstNameMess = 'First name is required'
          }

          if (!lastName) {
               lastNameMess = 'Last name is required'
          }

          setErrorEmail(emailMess)
          setErrorPassword(passwordMess)
          setErrorFirstName(firstNameMess)
          setErrorLastName(lastNameMess)

          if (!emailMess && !passwordMess && !firstNameMess && !lastNameMess) {
               setLoading(true)
               axios.post(`${process.env.GATSBY_CALL_API}/signup/`, {
                    email,
                    password,
                    firstName,
                    lastName,
                    name: `${firstName} ${lastName}`,
                    packageId,
               })
                    .then(response => {
                         // Old version with activation link
                         // setLoading(false)
                         // setErrorForm()
                         // setSuccessRegister(response.data.message)

                         // New version
                         const { user, token } = response.data
                         Cookies.set('token', token, { expires: 1, domain: '.listenlayer.com' })
                         if (user.isLogin) {
                              window.open(`${process.env.GATSBY_APP_PATH}/?defaultPackageId=${packageId}`)
                         } else {
                              window.open(process.env.GATSBY_APP_PATH)
                         }
                         window.location.reload()
                    })
                    .catch(error => {
                         setLoading(false)
                         setSuccessRegister()
                         const message = error.response.data.message || error.response.data.error
                         setErrorForm(message || error.response.statusText)
                    })
          }
     }

     const handleEmailChange = event => {
          setEmail(event.target.value)
          setErrorEmail()
     }

     const handlePasswordChange = event => {
          setPassword(event.target.value)
          setErrorPassword()
     }

     const handleFirstNameChange = event => {
          setFirstName(event.target.value)
          setErrorFirstName()
     }

     const handleLastNameChange = event => {
          setLastName(event.target.value)
          setErrorLastName()
     }

     const handleClickLearn = () => {
          setShowLearnBox(!showLearnBox)
     }

     const onKeyNameEscape = event => {
          if (event.keyCode === 27) {
               setOpenLoginPopup(false)
               dispatch(setOpenPopupSignUp(false))
               dispatch(setPackageId(''))
          }
     }

     const getCookieToken = () => {
          if (typeof document !== 'undefined') {
               dispatch(setIsLogin(Cookies.get('token')))
          }
     }

     useEffect(getCookieToken, [])

     const [googleOneTap, setGoogleOneTap] = useState(false)
     const scriptFlag = '__googleOneTapScript__'

     const script = useScript('https://accounts.google.com/gsi/client')

     const onOneTapSignedIn = useCallback(
          response => {
               axios.post(`${process.env.GATSBY_CALL_API}/google-one-tap-login/`, {
                    oneTapToken: response.credential,
                    packageId: packageId,
                    ipAddress: ipAddress
               })
                    .then(response => {
                         dispatch(setIsLogin(true))
                         setLoading(false)
                         Cookies.set('token', response.data.token, {
                              expires: 1,
                              domain: '.listenlayer.com',
                         })
                         const user = response.data.user
                         if (user.isLogin) {
                              window.open(`${process.env.GATSBY_APP_PATH}/?defaultPackageId=${packageId}`)
                         } else {
                              window.open(process.env.GATSBY_APP_PATH)
                         }
                         window.location.reload()
                    })
                    .catch(error => {
                         setLoading(false)
                    })
          },
          [dispatch, packageId]
     )

     useEffect(() => {
          try {
               if (typeof window !== 'undefined' && script === 'ready') {
                    window.google.accounts.id.initialize({
                         client_id: process.env.GATSBY_APP_GOOGLE_CLIENT_ID,
                         prompt_parent_id: 'google-one-tap',
                         cancel_on_tap_outside: false,
                         callback: onOneTapSignedIn,
                    })
                    window[scriptFlag] = true
                    setGoogleOneTap(true)
               }
               if (window[scriptFlag] && script === 'ready' && openLoginPopup) {
                    window.google.accounts.id.prompt(notification => {
                         if (notification.isNotDisplayed() || notification.isSkippedMoment() || notification.getDismissedReason()) {
                              setGoogleOneTap(false)
                         }
                    })
               }
               return () => {
                    if (typeof window !== 'undefined' && script === 'ready') {
                         window.google.accounts.id.cancel()
                    }
               }
          } catch (error) {}
     }, [script, openLoginPopup, onOneTapSignedIn])

     useEffect(() => {
          try {
               if (typeof window !== 'undefined' && script === 'ready') {
                    window.google.accounts.id.initialize({
                         client_id: process.env.GATSBY_APP_GOOGLE_CLIENT_ID,
                         prompt_parent_id: 'google-one-tap-register',
                         cancel_on_tap_outside: false,
                         callback: onOneTapSignedIn,
                         context: 'signup',
                    })
                    window[scriptFlag] = true
                    setGoogleOneTap(true)
               }
               if (window[scriptFlag] && script === 'ready' && isOpenPopupSignUp) {
                    window.google.accounts.id.prompt(notification => {
                         if (notification.isNotDisplayed() || notification.isSkippedMoment() || notification.getDismissedReason()) {
                              setGoogleOneTap(false)
                         }
                    })
               }
               return () => {
                    if (typeof window !== 'undefined' && script === 'ready') {
                         window.google.accounts.id.cancel()
                    }
               }
          } catch (error) {}
     }, [script, isOpenPopupSignUp, onOneTapSignedIn])

     const ref = useRef(null)

     const onClickOutside = () => {
          setShowLearnBox(false)
     }

     useEffect(() => {
          const handleClickOutside = event => {
               if (ref.current && !ref.current.contains(event.target)) {
                    onClickOutside && onClickOutside()
               }
          }
          document.addEventListener('click', handleClickOutside, true)
          return () => {
               document.removeEventListener('click', handleClickOutside, true)
          }
     }, [() => onClickOutside]) // eslint-disable-line react-hooks/exhaustive-deps

     const onClickGetStarted = () => {
          navigate(`${process.env.GATSBY_APP_PATH}/register/?navigate=true`)
          // window.location.replace(`${process.env.GATSBY_APP_PATH}/register`)
     }

     const [checkPageHome, setCheckPageHome] = useState(false)

     useEffect(() => {
          if (window.location.pathname === '/') {
               setCheckPageHome(true)
          } else {
               setCheckPageHome(false)
          }
     }, [])

     return (
          <>
               <header role="banner" className={`${isActiveMenu ? 'header-active-mobile' : ''}`}>
                    <div className="container">
                         <div className="wrap-header">
                              <div className="logo">
                                   {darkMode || (checkPageHome && !isActiveMenu) ? (
                                        <a
                                             href="/"
                                             aria-label="Logo Header"
                                             dangerouslySetInnerHTML={{
                                                  __html: `<svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" viewBox="0 0 242.68 38.68"><g id="Layer_1-2"><g id="Layer_2-2"><g id="Layer_1-2"><path d="M32.68,25.3l-13.27,7.77c-1.14,.67-2.55,.67-3.69,0L2.45,25.3l-1.4,.8c-.97,.53-1.33,1.74-.8,2.71,.18,.34,.46,.61,.8,.8l14.64,8.57c1.14,.67,2.55,.67,3.69,0l14.67-8.57c.97-.53,1.33-1.74,.8-2.71-.18-.34-.46-.61-.8-.8l-1.37-.8Z" style="fill:#d8d8d8; fill-rule:evenodd;"/><path d="M32.68,16.79l-13.27,7.77c-1.14,.66-2.55,.66-3.69,0L2.45,16.79l-1.4,.79c-.97,.52-1.33,1.74-.81,2.71,.19,.34,.47,.62,.81,.81l14.64,8.57c1.14,.66,2.55,.66,3.69,0l14.67-8.57c.97-.52,1.33-1.74,.81-2.71-.19-.34-.47-.62-.81-.81l-1.37-.79Z" style="fill:#20a8d8; fill-rule:evenodd;"/><path d="M15.72,21.15L1.05,12.58c-.97-.53-1.33-1.74-.8-2.71,.18-.34,.46-.61,.8-.8L15.72,.5c1.14-.67,2.55-.67,3.69,0l14.64,8.57c.97,.53,1.33,1.74,.8,2.71-.18,.34-.46,.61-.8,.8l-14.64,8.57c-1.14,.67-2.55,.67-3.69,0Z" style="fill:#ffc107; fill-rule:evenodd;"/><path d="M52.74,8.44V24.86c0,.86,.69,1.55,1.55,1.55h5.49v3.4h-11.32V10.42c0-1.1,.9-2,2-2l2.28,.02Z" style="fill:#f0f4f7;"/><path d="M64.95,8.44h2.31V29.81h-4.28V10.42c.01-1.09,.88-1.96,1.97-1.98Z" style="fill:#f0f4f7;"/><path d="M78.39,30c-4.44,0-7.86-2.32-7.93-6.36h3.08c.81,.04,1.53,.53,1.85,1.27,.57,1.06,1.71,1.68,2.91,1.57,2,0,3.21-1.07,3.21-2.6,0-4.62-11-1.83-11-9.58,0-3.85,3.12-6.18,7.52-6.18s7.38,2.23,7.66,6.09h-3.35c-.72-.04-1.35-.47-1.67-1.11-.58-.95-1.63-1.5-2.74-1.43-1.68-.06-2.94,.77-2.94,2.51,0,4.28,11,1.9,11,9.43-.04,3.39-2.73,6.39-7.6,6.39Z" style="fill:#f0f4f7;"/><path d="M119.19,11.9h-7.36c-.42,0-.75,.34-.75,.76v4.6h7.19v3.4h-7.22v5.66h8.11v3.49h-12.4V9.64c0-.68,.55-1.23,1.23-1.23,.02,0,.04,0,.06,0h11.18l-.04,3.49Z" style="fill:#f0f4f7;"/><path d="M140.65,8.41V29.81h-3.22c-.66,0-1.28-.34-1.65-.89l-9.11-13.77v14.66h-4.29V8.41h3.22c.66,0,1.28,.34,1.65,.89l9.12,13.81V8.41h4.28Z" style="fill:#f0f4f7;"/><path d="M175.6,25.07h-9.3l-1.72,4.74h-2.93l7.24-19.91c.29-.77,1.02-1.29,1.85-1.3h1.83l7.69,21.21h-2.94l-1.72-4.74Zm-4.65-13.07l-3.85,10.8h7.71l-3.86-10.8Z" style="fill:#f0f4f7;"/><path d="M180.26,8.48h3.09l4.16,8.52c.29,.61,1.02,.86,1.63,.57,.25-.12,.45-.32,.57-.57l4.17-8.54h3.09l-6.92,13.3v8h-2.79v-8l-7-13.28Z" style="fill:#f0f4f7;"/><path d="M211.18,10.74h-7.94c-.42,0-.76,.34-.76,.76v6.37h7.78v2.3h-7.78v7.34h8.7v2.3h-11.48V9.67c0-.67,.54-1.22,1.21-1.23h10.27v2.3Z" style="fill:#f0f4f7;"/><path d="M221.26,8.48c5,0,7.4,2.78,7.4,6.27,.1,3.03-2.08,5.66-5.08,6.12l5.36,8.94h-3.34l-5.08-8.72h-3.36v8.72h-2.79V10.45c0-1.1,.9-2,2-2l4.89,.03Zm0,2.29h-2.88c-.67,0-1.22,.55-1.22,1.22h0v6.87h4.1c3.15,0,4.53-1.71,4.53-4.1s-1.35-3.99-4.53-3.99Z" style="fill:#f0f4f7;"/><path d="M103.61,8.45v3.46h-5.71V29.81h-4.28V11.91h-5.69v-2.48c0-.55,.45-1,1-1l14.68,.02Z" style="fill:#f0f4f7;"/><path d="M159.27,27.53v2.28h-10.22V9.46c0-.55,.45-1,1-1h1.8V26.31c0,.67,.53,1.21,1.2,1.22h6.22Z" style="fill:#f0f4f7;"/><path d="M236.34,9.33v4.27h-1v-4.27h-1.29v-.85h3.59v.85h-1.3Z" style="fill:#f0f4f7;"/><path d="M242.68,13.6h-1v-3l-1,2h-.63l-1-2.07v3.07h-1v-5.12h1l1.32,2.83,1.3-2.83h1v5.12Z" style="fill:#f0f4f7;"/></g></g></g></svg>`,
                                             }}
                                             target="_self"
                                        ></a>
                                   ) : (
                                        <a
                                             href="/"
                                             aria-label="Logo Header"
                                             dangerouslySetInnerHTML={{
                                                  __html: headerLogo,
                                             }}
                                             target="_self"
                                        ></a>
                                   )}

                                   <button
                                        className={`hamburger is-mobile ${checkPageHome && !isActiveMenu ? 'home-page' : ''} ${
                                             isActiveMenu && 'is-active'
                                        }`}
                                        onClick={() => clickHamburger()}
                                   >
                                        <span></span>
                                        <span></span>
                                   </button>
                              </div>
                              <div
                                   className={`header-menu ${checkPageHome && !isActiveMenu ? 'home-page' : ''} ${darkMode ? 'dark-theme' : ''} ${
                                        isActiveMenu ? 'menu-mobile' : ''
                                   }`}
                              >
                                   {menuData && (
                                        <nav className="main-menu" role="navigation">
                                             {isActiveMenu ? renderMenuItemsMobile(menuData, 1) : renderMenuItems(menuData, 1)}
                                        </nav>
                                   )}

                                   <div className={`login-signup ${isLogin ? 'dashboard' : ''}`}>
                                        {(turnOffPodcast || urlPodcast || turnOffMasterclass || urlMasterclass) && (
                                             <div className="learn-option">
                                                  <button
                                                       className={`learn-option-select${showLearnBox ? ' show-learn' : ''}`}
                                                       onClick={handleClickLearn}
                                                  >
                                                       <span className="learn-option-text">Learn</span>
                                                       <svg className="learn-option-svg" width="7px" height="6px" viewBox="0 0 7 6" version="1.1">
                                                            <defs>
                                                                 <filter id="filter_1">
                                                                      <feColorMatrix
                                                                           in="SourceGraphic"
                                                                           type="matrix"
                                                                           values="0 0 0 0 0.1254902 0 0 0 0 0.65882355 0 0 0 0 0.84705883 0 0 0 1 0"
                                                                      />
                                                                 </filter>
                                                            </defs>
                                                            <g id="icon-type3chevron-bottom" transform="matrix(1.1924881E-08 1 -1 1.1924881E-08 7 0)">
                                                                 <g
                                                                      id="icon-type3chevron-bottom"
                                                                      transform="matrix(1.1924881E-08 1 -1 1.1924881E-08 5.6925 -0.39975035)"
                                                                 >
                                                                      <path
                                                                           d="M7.5699 1.31961L6.27287 2.51728e-16L3.78495 2.53123L1.29703 0L0 1.31961L3.78593 5.17144L5.08295 3.85183L5.08198 3.85084L7.5699 1.31961L7.5699 1.31961Z"
                                                                           transform="translate(0.11532857 0.09622145)"
                                                                           id="Shape"
                                                                           fill="#708393"
                                                                           fillRule="evenodd"
                                                                           stroke="none"
                                                                      />
                                                                 </g>
                                                            </g>
                                                       </svg>
                                                  </button>
                                                  <div className="learn-option-box" ref={ref}>
                                                       {/* {!turnOffPodcast && urlPodcast && (
                                                            <div className="learn-option-item podcast">
                                                                 <a href={addSlashButtonLink(urlPodcast)}>
                                                                      {podcastLogo && (
                                                                           <div
                                                                                className="icon"
                                                                                dangerouslySetInnerHTML={{
                                                                                     __html: podcastLogo,
                                                                                }}
                                                                           ></div>
                                                                      )}
                                                                      <div className="text">
                                                                           {topTextPodcast && <span>{'Join the weekly'}</span>}
                                                                           {bottomTextPodcast && <span>{'Webinar'}</span>}
                                                                      </div>
                                                                 </a>
                                                            </div>
                                                       )} */}
                                                       {!turnOffPodcast && urlPodcast && (
                                                            <div className="learn-option-item podcast">
                                                                 <a href={addSlashButtonLink(urlPodcast)}>
                                                                      {podcastLogo && (
                                                                           <div
                                                                                className="icon"
                                                                                dangerouslySetInnerHTML={{
                                                                                     __html: podcastLogo,
                                                                                }}
                                                                           ></div>
                                                                      )}
                                                                      <div className="text">
                                                                           {topTextPodcast && <span>{topTextPodcast}</span>}
                                                                           {bottomTextPodcast && <span>{bottomTextPodcast}</span>}
                                                                      </div>
                                                                 </a>
                                                            </div>
                                                       )}
                                                       {!turnOffMasterclass && urlMasterclass && (
                                                            <div className="learn-option-item masterclass">
                                                                 <a href={addSlashButtonLink(urlMasterclass)}>
                                                                      {masterclassLogo && (
                                                                           <div
                                                                                className="icon"
                                                                                dangerouslySetInnerHTML={{
                                                                                     __html: masterclassLogo,
                                                                                }}
                                                                           ></div>
                                                                      )}
                                                                      <div className="text">
                                                                           {topTextMasterclass && <span>{topTextMasterclass}</span>}
                                                                           {bottomTextMasterclass && <span>{bottomTextMasterclass}</span>}
                                                                      </div>
                                                                 </a>
                                                            </div>
                                                       )}
                                                  </div>
                                             </div>
                                        )}
                                        {!isLogin ? (
                                             <>
                                                  <div className="login is-desktop">
                                                       <button onClick={() => setOpenLoginPopup(true)}>Login</button>
                                                  </div>
                                                  <button className="signup" onClick={() => onClickGetStarted()}>
                                                       Get started
                                                  </button>
                                                  <div className="login-mobile is-mobile">
                                                       <span>Already a user? </span>
                                                       <button onClick={() => setOpenLoginPopup(true)}>Login</button>
                                                  </div>
                                             </>
                                        ) : (
                                             <a className="signup" href={process.env.GATSBY_APP_PATH} target="_blank" rel="noreferrer">
                                                  MY ACCOUNT
                                             </a>
                                        )}
                                   </div>
                              </div>
                         </div>
                    </div>
               </header>
               {openLoginPopup && (
                    <div className="login-form-modal">
                         <div className="login-section-main">
                              <div className="login-section-card-wrapper">
                                   <button className="login-icon-close" onClick={() => closePopup()}>
                                        <img width="20" height="20" alt="Icon Close" src="/images/icon-close.svg" />
                                   </button>
                                   <div className="login-section-card-scroll">
                                        <div className={`login-section-card member-login${googleOneTap ? ' has-google-one-tap' : ''}`}>
                                             <div className="login-section-card-title">
                                                  <h2>Member Login</h2>
                                             </div>
                                             <div className="login-section-card-description">
                                                  <p>
                                                       Log in to your ListenLayer<sup>TM</sup> account
                                                  </p>
                                             </div>
                                             <form className="website-login" onSubmit={handleSubmitForm}>
                                                  <div className="field-wrapper">
                                                       <input
                                                            type="text"
                                                            aria-required="true"
                                                            name="email-login"
                                                            placeholder="Enter your email"
                                                            onChange={handleEmailChange}
                                                       />
                                                       {errorEmail && <div className="login-invalid-feedback">{errorEmail}</div>}
                                                  </div>
                                                  <div className="field-wrapper">
                                                       <input
                                                            type="password"
                                                            aria-required="true"
                                                            name="password-login"
                                                            placeholder="Enter your password"
                                                            onChange={handlePasswordChange}
                                                       />
                                                       {errorPassword && <div className="login-invalid-feedback">{errorPassword}</div>}
                                                  </div>
                                                  <div className="login-section-card-button">
                                                       <button type="submit" className="btn">
                                                            {loading ? (
                                                                 <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                            ) : (
                                                                 'Login'
                                                            )}
                                                       </button>
                                                       {errorForm && <div className="error form">{errorForm}</div>}
                                                       <a
                                                            href={`${process.env.GATSBY_APP_PATH}/auth/password/forgot`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                       >
                                                            Reset Password?
                                                       </a>
                                                  </div>
                                             </form>
                                             <div className="login-card-with-google">
                                                  <div id="google-one-tap"></div>
                                                  {!googleOneTap && (
                                                       <Google className="btn-google-outline" labelButton="Login with Google" isIconColor={true} />
                                                  )}
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              <div className="login-section-card below-form">
                                   <a href={`${process.env.GATSBY_APP_PATH}/register`} target="_blank" rel="noreferrer">
                                        Get started
                                   </a>
                              </div>
                         </div>
                         <div
                              aria-label="overlay form"
                              tabIndex="-1"
                              role="button"
                              onClick={() => {
                                   closePopup()
                              }}
                              onKeyDown={onKeyNameEscape}
                              className="form-overlay"
                         ></div>
                    </div>
               )}
               {isOpenPopupSignUp && (
                    <div className="login-form-modal">
                         <div className="login-section-main">
                              <div className="login-section-card-wrapper">
                                   <button className="login-icon-close" onClick={() => closePopup()}>
                                        <img width="20" height="20" alt="Icon Close" src="/images/icon-close.svg" />
                                   </button>
                                   <div className="login-section-card-scroll">
                                        <div className={`login-section-card member-login${googleOneTap ? ' has-google-one-tap' : ''}`}>
                                             <div className="login-section-card-title">
                                                  <h2>Create an Account</h2>
                                             </div>
                                             <div className="login-section-card-description">
                                                  <p>Create a ListenLayer account to supercharge your website data with powerful Listeners.</p>
                                             </div>
                                             <form className="website-create-account" onSubmit={handleSubmitFormRegister}>
                                                  <div className="input-fullname">
                                                       <div className="field-wrapper">
                                                            <input
                                                                 type="text"
                                                                 aria-required="true"
                                                                 name="firstName-create"
                                                                 placeholder="First name"
                                                                 onChange={handleFirstNameChange}
                                                            />
                                                            {errorFirstName && <div className="login-invalid-feedback">{errorFirstName}</div>}
                                                       </div>
                                                       <div className="field-wrapper">
                                                            <input
                                                                 type="text"
                                                                 aria-required="true"
                                                                 name="lastName-create"
                                                                 placeholder="Last name"
                                                                 onChange={handleLastNameChange}
                                                            />
                                                            {errorLastName && <div className="login-invalid-feedback">{errorLastName}</div>}
                                                       </div>
                                                  </div>
                                                  <div className="field-wrapper">
                                                       <input
                                                            type="text"
                                                            aria-required="true"
                                                            name="email-create"
                                                            placeholder="Email address"
                                                            onChange={handleEmailChange}
                                                       />
                                                       {errorEmail && <div className="login-invalid-feedback">{errorEmail}</div>}
                                                  </div>
                                                  <div className="field-wrapper">
                                                       <input
                                                            type="password"
                                                            aria-required="true"
                                                            name="password-create"
                                                            placeholder="Password"
                                                            onChange={handlePasswordChange}
                                                       />
                                                       {errorPassword && <div className="login-invalid-feedback">{errorPassword}</div>}
                                                  </div>
                                                  <div className="login-section-card-button register-section-card-button">
                                                       <button type="submit" className="btn">
                                                            {loading ? (
                                                                 <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                            ) : (
                                                                 'Get Started'
                                                            )}
                                                       </button>
                                                       {errorForm && <div className="error form">{errorForm}</div>}
                                                       {successRegister && <div className="success form">{successRegister}</div>}
                                                  </div>
                                             </form>
                                             <div className="login-card-with-google">
                                                  <div id="google-one-tap-register"></div>
                                                  {!googleOneTap && (
                                                       <Google className="btn-google-outline" labelButton="Sign Up With Google" isIconColor={true} />
                                                  )}
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                         <div
                              aria-label="overlay form"
                              tabIndex="-1"
                              role="button"
                              onClick={() => {
                                   closePopup()
                              }}
                              onKeyDown={onKeyNameEscape}
                              className="form-overlay"
                         ></div>
                    </div>
               )}
          </>
     )
}

Header.propTypes = {
     siteTitle: PropTypes.string,
}

Header.defaultProps = {
     siteTitle: ``,
}

export default Header
